import * as React from 'react';
import {datagridCustomColumn, DynamicDatagrid, IDataGridProps, MuiDataGrid, Paper, Typography} from "@leap4/frontend";
import {ScrapingUtils} from "../../../../../utils/scraping.utils";
import PercentCell from "../../../../shared/PercentCell/PercentCell";
import {tableStyling} from "./ConnectedTagsDialog/Table/tableStyling";
import {Link} from "react-router-dom";
import {urlService} from "../../../../routing/urlsService";
import {IPublisherTagDisc} from "../../interfaces/DataPointDtoMainPage.interface";
type GridRowModel = MuiDataGrid.GridRowModel;

const align = 'left'

function createRowData(item: IPublisherTagDisc): GridRowModel {
    return {
        id: item.tag._id,
        name: item.tag.name,
        campaignId: item.tag.campaignId,
        revenue: item.publisherRevenue,
        impressions: item.publisherImpressions,
        discrepancyRevPerc: item?.revenueDiscPercent,
        discrepancyImpsPerc: item.impressionsDiscPercent,
        discrepancyRevVal: item.revenueDiscValue,
        discrepancyImpsVal: item.impressionsDiscValue,
        connectedCount: item.connectedTagsCount,
        connectedRev: item.adServerRevenue,
        connectedImps: item.adServerImpressions,
    }
}


export interface ITagsTableProps extends Partial<IDataGridProps> {
    items: Array<IPublisherTagDisc>,
    loading: boolean,
}

export default function TagsTable({items, loading, refreshFunc}: ITagsTableProps) {

    const columns: datagridCustomColumn[] = [
        {
            field: 'name',
            headerName: 'Name',
            width: 150,
            renderCell: (params => {
                return <Link to={`${urlService.publisherTag(params.id.toString(), true)}`}>
                    <Typography   style={{fontWeight:"bolder"}}> {params.value}</Typography>
                </Link>
            })
        },
        {
            field: 'campaignId',
            headerName: 'Campaign ID',
            width: 300,
        },
        {
            field: 'revenue',
            headerName: 'Advertiser Revenue',
            type: 'number',
            width: 150,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('revenue', params.value as number)
            }
        },
        {
            field: 'impressions',
            headerName: 'Advertiser Impressions',
            type: 'number',
            width: 150,
            headerAlign: align,
            align,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('impressions', params.value as number)
            }
        },
        {
            field: "discrepancyRevVal",
            headerName: "Disc Revenue",
            sortable: true,
            width: 125,
            headerAlign: align,
            align: 'center',
            cellClassName: params => {
                let cellClassName = `default-cell `
                if (params.value === null) cellClassName += 'no-value'
                else if (params.value > 0) cellClassName += 'positive'
                else if (params.value < 0) cellClassName += 'negative'
                return cellClassName;
            },
            renderCell: params => {
                const val = params?.value as number;
                return <>
                    {ScrapingUtils.addSignsToMetricValue("revenue", val)}
                </>
            }
        },

        {
            field: "discrepancyRevPerc",
            headerName: "Disc Rev Percent",
            sortable: true,
            headerAlign: align,
            align,
            width: 145,
            renderCell: params => {
                const percent = params?.value as number;
                return <>
                    <PercentCell percent={percent}/>
                </>
            }
        },


        {
            field: "discrepancyImpsVal",
            headerName: "Disc Imps",
            sortable: true,
            headerAlign: align,
            align: 'center',
            width: 110,
            cellClassName: params => {
                let cellClassName = `default-cell `
                if (params.value === null) cellClassName += 'no-value'
                else if (params.value > 0) cellClassName += 'positive'
                else if (params.value < 0) cellClassName += 'negative'
                return cellClassName;
            },
            renderCell: params => {
                const value = params?.value as number;
                return <Typography

                    variant={"caption"}> {ScrapingUtils.addSignsToMetricValue("impressions", value)} </Typography>


            }
        },
        {
            field: "discrepancyImpsPerc",
            headerName: "Disc Imps Percent",
            sortable: true,
            width: 155,
            headerAlign: align,
            align,
            renderCell: params => {
                const percent = params?.value as number;
                return <>
                    <PercentCell percent={percent}/>
                </>
            }
        },

        {

            field: 'connectedCount',
            headerName: 'Connected Tags',
            type: 'number',
            minWidth: 130,
            align: "center",
            headerAlign: "center"

        },
        {
            field: 'connectedRev',
            headerName: 'Server Revenue',
            type: 'number',
            headerAlign: align,
            align,
            width: 125,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('revenue', params.value as number)
            }
        },
        {
            field: 'connectedImps',
            headerName: 'Server Imps',
            type: 'number',
            width: 120,
            headerAlign: align,
            align,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('impressions', params.value as number)
            }
        },
    ];


    const rows = items.map((row) =>
        createRowData(row)
    ).sort((a,b) => b.revenue > a.revenue ? 1 : -1);

    return (
        <Paper sx={{margin: "20px 0" ,borderRadius: "16px", ...tableStyling.paperTable}} elevation={5}>
            <DynamicDatagrid rows={rows}
                             columns={columns}
                             loading={loading}
                             loadError={false}
                             pageSize={100}
                             refreshFunc={refreshFunc}
                             style={{minHeight: `75vh`, width: '100%'}}
            />
        </Paper>
    )

        ;
}
